import {combineReducers} from 'redux';

import {AllLawDocsRed } from './getLawDocsREd';
const reducer = combineReducers({
   AllLawDocsRed
    });
    
    export default reducer;
